import React from "react";

export default function TableItem({ AppleSMSLink, handleEdit, handleDelete }) {
  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) return Math.floor(interval) + " years ago";
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + " months ago";
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + " days ago";
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + " hours ago";
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + " minutes ago";
    return Math.floor(seconds) + " seconds ago";
  }

  return (
    <tr key={AppleSMSLink.id}>
      <td className="customer_name">{AppleSMSLink.id}</td>
      <td className="email">{AppleSMSLink.email}</td>
      <td className="phone">{AppleSMSLink.phone || "-"}</td>
      <td className="taken">{AppleSMSLink.taken_count || 0} / 3</td>
      <td className="date">{timeSince(new Date(AppleSMSLink.created_at))}</td>
      <td>
        <div className="d-flex gap-2">
          <button
            className="btn btn-md btn-success edit-item-btn"
            onClick={() => handleEdit(AppleSMSLink)}
          >
            <i className="ri-edit-line align-bottom"></i>
          </button>
          <button
            className="btn btn-danger btn-md remove-item-btn"
            onClick={() => handleDelete(AppleSMSLink.id)}
          >
            <i className="ri-delete-bin-6-line align-bottom"></i>
          </button>
        </div>
      </td>
    </tr>
  );
}
